import React, { useState } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Controller } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { SanityMediaCarousel } from "@graphql-types";
import { AbsoluteWrapper, Container } from "@util/standard";
import { Image, Video } from "@global";
import { CircleArrow, PlayButton } from "@util/assets";
import { isSanityImageWithMeta, isSanityVideo } from "@util/types";
import { mediaQuery } from "@util/constants";

interface Props {
  data: SanityMediaCarousel;
}

const StyledSwiper = styled(Swiper)`
  width: 100%;
  max-height: 800px;
`;

const SliderNav = styled(AbsoluteWrapper)`
  z-index: 2;

  height: max-content;
  top: 50%;
  transform: translateY(-50%);

  ${mediaQuery.largeDown} {
    top: unset;
    bottom: 0px;
  }
`;

function MediaCarousel({ data }: Props) {
  if (data == null) return null;
  const [controlledSwiper, setControlledSwiper] = useState<SwiperCore>();
  const { carouselContent } = data;

  const handleSlideChange = (next?: boolean) => {
    if (controlledSwiper) {
      next ? controlledSwiper.slideNext() : controlledSwiper.slidePrev();
    }
  };

  return (
    <Container height="100%" position="relative" backgroundColor="charcoal">
      <SliderNav left="6%">
        <CircleArrow onClick={() => handleSlideChange()} />
      </SliderNav>
      <SliderNav right="6%">
        <CircleArrow flip onClick={() => handleSlideChange(true)} />
      </SliderNav>
      <StyledSwiper
        modules={[Controller, Pagination]}
        draggable={false}
        allowTouchMove={false}
        onSwiper={setControlledSwiper}
        preventClicks={false}
        loop
      >
        {carouselContent &&
          carouselContent.map(content => {
            const [videoPlayerOpen, setVideoPlayerOpen] = useState(false);
            if (isSanityVideo(content)) {
              if (content.url == null) return null;
              return (
                <SwiperSlide key={content._key}>
                  <Container height="100%" width="100%">
                    {(videoPlayerOpen || !content.image) && (
                      <Video
                        url={content.url}
                        autoPlayOnLoad={videoPlayerOpen}
                        volume={videoPlayerOpen}
                        currentTime={videoPlayerOpen ? 0 : null}
                        foregroundOpen
                        controls={videoPlayerOpen}
                        width="80%"
                      />
                    )}

                    {!videoPlayerOpen && (
                      <Container position="relative" width="100%">
                        {content.image && !videoPlayerOpen && (
                          <Image data={content.image} width="100%" objectFit="cover" isBackground />
                        )}
                        <PlayButton onClick={() => setVideoPlayerOpen(true)} />
                      </Container>
                    )}
                  </Container>
                </SwiperSlide>
              );
            }
            if (isSanityImageWithMeta(content)) {
              return (
                <SwiperSlide key={content._key}>
                  <Container width="100%" height="100%">
                    <Image data={content} width="100%" height="100%" objectFit="cover" />
                  </Container>
                </SwiperSlide>
              );
            }
            return null;
          })}
      </StyledSwiper>
    </Container>
  );
}

export default MediaCarousel;
